import { Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatCalendar } from '@angular/material/datepicker';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { startWith } from 'rxjs/operators';

import { MdwButton } from '@spaces-ui/meadow/components/button';
import { Navigate_Next, Navigate_Previous } from '@spaces-ui/meadow/icons/svgs';

@UntilDestroy()
@Component({
  selector: 'mdw-date-picker-header',
  templateUrl: './date-picker-header.html',
  styleUrls: ['./date-picker-header.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MdwButton],
})
export class MdwDatePickerHeader<D> {
  private calendar = inject<MatCalendar<D>>(MatCalendar);
  private dateAdapter = inject<DateAdapter<D>>(DateAdapter);
  private dateFormats = inject(MAT_DATE_FORMATS);

  public monthLabel = signal('');
  public yearLabel = signal('');

  public icons = { Navigate_Next, Navigate_Previous };

  public constructor() {
    this.calendar.stateChanges.pipe(startWith(null), untilDestroyed(this)).subscribe(() => {
      this.monthLabel.set(
        this.dateAdapter.getMonthNames('short')[
          this.dateAdapter.getMonth(this.calendar.activeDate)
        ],
      );

      this.yearLabel.set(this.dateAdapter.getYearName(this.calendar.activeDate));
    });
  }

  public changeMonth(increment: -1 | 1) {
    this.calendar.activeDate = this.dateAdapter.addCalendarMonths(
      this.calendar.activeDate,
      increment,
    );
  }

  public changeYear(increment: -1 | 1) {
    if (this.calendar.currentView === 'multi-year') {
      this.calendar.activeDate = this.dateAdapter.addCalendarYears(
        this.calendar.activeDate,
        increment * 24,
      );
    } else {
      this.calendar.activeDate = this.dateAdapter.addCalendarYears(
        this.calendar.activeDate,
        increment,
      );
    }
  }

  public setView(view: 'month' | 'year' | 'multi-year') {
    this.calendar.currentView = this.calendar.currentView === view ? 'month' : view;
  }
}
